export const UserType = {
  FEREO_VR: "fereo-vr",
  FEREO_WEB: "fereo-web",
  TRIALSNET_VR: "trialsnet-vr",
  TRIALSNET_WEB: "trialsnet-web",
  XREL_TEACHER_HOLOGRAM: "xrel-teacher-hologram",
  XREL_VR: "xrel-vr",
  XREL_WEB: "xrel-web",
  XREL_WEB_STUDENT: "xrel-web-student"
} as const;

export type UserType = (typeof UserType)[keyof typeof UserType];
